<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      location="bottom"
      offset="6">
      <template #activator="{ props }">
        <v-btn v-bind="props">
          <v-icon class="mr-1">mdi-plus</v-icon>
          Додати
        </v-btn>
      </template>
      <v-card
        :loading="$loading.isLoading('docTypeDefinitions')"
        class="select-menu"
        min-width="300px">
        <div class="menu-search">
          <v-text-field
            v-model="search"
            density="compact"
            hide-details
            placeholder="Пошук типу документа..."
            prepend-inner-icon="mdi-magnify"
            variant="plain" />
        </div>
        <v-list
          class="bg-white scrollable-list"
          color="secondary"
          density="compact">
          <v-list-item
            v-for="item in items"
            :key="item.id"
            class="menu-item pl-3"
            min-height="32px"
            @click="selectItem(item)">
            <v-list-item-title class="font-size-13 font-weight-bold">
              {{ item.name }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="!items.length">
            <v-list-item-title class="text-grey">
              Нічого не знайдено
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { fillDirectory, getDirectory } from '@/directory'

defineOptions({
  name: 'EntitySelectMenu',
})

const props = defineProps<{
  directoryKey: string
  selectedItems?: any[]
}>()

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'select-item', item: any): void
}>()

const menu = ref(false)
const search = ref('')

onMounted(() => {
  fillDirectory(props.directoryKey)
})

const items = computed(() => {
  const allItems: any[] = getDirectory(props.directoryKey) || []

  const selectedIds = new Set((props.selectedItems || []).map(i => i.id))

  const filtered = allItems.filter(item => !selectedIds.has(item.id))

  if (!search.value) return filtered

  const searchLower = search.value.toLowerCase()

  return filtered.filter(item => item.name?.toLowerCase().includes(searchLower))
})

const selectItem = (item: any) => {
  emit('select-item', item)
  menu.value = false
}
</script>

<style lang="scss" scoped>
.select-menu {
  min-width: 260px;
  border-radius: 14px !important;
  padding: 6px;
  animation: ntmDdIn 0.12s ease !important;
  border: 1.5px solid rgb(var(--v-theme-surface-border)) !important;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.14) !important;

  :deep(.v-list) {
    max-height: 200px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgb(var(--v-theme-darkGrey));
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgb(var(--v-theme-grey));
    }
  }
}

.scrollable-list {
  max-height: 195px;
  overflow-y: auto !important;
}

.menu-search {
  padding: 0 8px 3px;
  border-bottom: 1px solid rgb(var(--v-theme-surface-border));
}

.menu-item {
  border-radius: 10px;
  padding: 6px 8px;

  &:hover {
    background: rgb(var(--v-theme-surface)) !important;
  }
}
</style>
